import React from "react";
import PropTypes from "prop-types";
import { TranslationFn } from "lib/types";

import { QuestionComponentType, QuestionProps } from "./types";
import GuidedTextarea from "./GuidedTextarea";

const LongAnswer: QuestionComponentType = (
    // eslint-disable-next-line camelcase
    {
        handleAnswer,
        question,
        id,
        isAnonymous,
        question_set_question,
        image_url: imageUrl,
        ...props
    }: QuestionProps,
    { t: _ }: { t: TranslationFn },
) => {
    const handleSubmit = (value: string) => {
        handleAnswer({
            question_set_question, // eslint-disable-line camelcase
            questionID: id,
            response: value,
            selfIdentified: !isAnonymous,
        });
    };
    return (
        <GuidedTextarea
            {...props}
            id={id}
            questionText={question}
            handleSubmit={handleSubmit}
            visible
            placeholder={_("Let us know how we can improve")}
            dataTest="further-feedback-text-area"
            isAnonymous={isAnonymous}
            imageUrl={imageUrl}
        />
    );
};

LongAnswer.contextTypes = {
    t: PropTypes.func,
};

export default LongAnswer;
